import { connect } from 'react-redux'
import { modalActions } from 'store/modal'
import VisitTemplateView from '../components/VisitTemplateView'
import { getHeaderName, getSelectedTab } from '../../../utils/visitNameUtils'
import { getStudyVersionID, isVersionUatOrLive } from '../../../../../../../../../utils/studyConfigUtils'
import { getLastPathSegment } from 'utils/navigation'

const mapState = state => {
  const { loading, location, study, subroute } = state
  const studyVersionID = getStudyVersionID(location)
  const path = getLastPathSegment(location?.pathname)
  const studyID = study.currentStudy.id
  const isArmsSupported = study?.currentStudy?.config?.visit_support?.arms_enabled
  const { studyVersionList } = study

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  return {
    headerName: getHeaderName(path, subroute, isArmsSupported, isReadOnlyState),
    loading: loading.general,
    path,
    preview: path === 'preview',
    selectedTab: getSelectedTab(path, isArmsSupported, isReadOnlyState),
    studyID,
    subroute,
    isArmsSupported,
    isReadOnlyState,
    studyVersionID,
  }
}

const mapDispatch = modalActions

export default connect(mapState, mapDispatch)(VisitTemplateView)
